import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, OnInit } from '@angular/core';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})


export class ContactComponent implements OnInit,AfterViewInit {



  nombreCompleto:string;
  empresa:string;
  email:any;
  celular:any;
  subject:string;
  message:string;

  constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef) { }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    const s = this.document.createElement('script');
    s.type = 'text/javascript';
    s.src = '../assets/js/email.js';
    const __this = this; //to store the current instance to call
                         //afterScriptAdded function on onload event of
                         //script.
    s.onload = function () { __this.afterScriptAdded(); };
    this.elementRef.nativeElement.appendChild(s);
  }

  afterScriptAdded() {
    const params= {
      width: '350px',
      height: '420px',
    };
    if (typeof (window['functionFromExternalScript']) === 'function') {
      window['functionFromExternalScript'](params);
    }
  }
  onSubmit(e: Event){

  }
  validateFields():boolean{
    if (this.nombreCompleto == "" || this.nombreCompleto === undefined)
    {
      return true;
    };
    if (this.empresa == "" || this.empresa === undefined)
      {
        return true;
      };
    if (this.celular == "" || this.celular === undefined)
      {
        return true;
      };
    if (this.email == "" || this.email === undefined)
      {
        return true;
      };
    if(this.email != "" && this.validateEmail(this.email) == false)
    {
      return true;
    }
    // if (this.subject == "" || this.subject === undefined)
    //   {
    //     return true;
    //   };
    if (this.message == "" || this.message === undefined)
      {
        return true;
      };
    return false;
  }
  validateEmail(email) {
    if (email == "" || this.email === undefined) {
      return true;
    }
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
}
